import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { Controller, Resolver, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { formatData } from "../../common";
import { gradeListSelect, STATUS } from "../../constant";
import { useGetAllBranch } from "../../hooks/query/useGetAllBranch";
import { useGetAllCourse } from "../../hooks/query/useGetAllCourse";
import { AppDispatch, RootState } from "../../store";
import { createStudent } from "../../store/slices/authSlice";
import Button from "../Button";
import InputArea from "../InputArea";
import InputDate from "../InputDate";
import InputSelect from "../InputSelect";
import InputText from "../InputText";
import Loading from "../Loading";
import NotionPopup from "../NotionPopup";
// import STATUS from '../../constant/index';

const schema = yup.object({
    studentName: yup.string().required("Họ và tên học sinh không được để trống"),
    parentName: yup.string().required("Họ và tên phụ huynh không được để trống"),
    birthDay: yup.string().required("Ngày sinh không được để trống"),
    email: yup.string().email("Email học sinh không hợp lệ").required("Email không được để trống"),
    password: yup
        .string()
        .matches(
            /^(?=.*[A-Za-z])(?=.*\d).{6,}$/,
            "Mật khẩu phải có ít nhất 6 ký tự, gồm chữ và số"
        )
        .required("Mật khẩu không được để trống"),
    phone: yup
        .string()
        .matches(/^(0|\+84)[0-9]{9,10}$/, "Số điện thoại không hợp lệ")
        .required("Số điện thoại là bắt buộc"),
    grade: yup.string().required("Lớp hiện tại không được để trống"),
    course: yup.string().required("Khóa học không được để trống"),
    branch: yup.string().required("Cơ sở không được để trống"),
    startDate: yup.string().required("Ngày bắt đầu không được để trống"),
    description: yup.string().nullable().default(null),
});

type FormData = yup.InferType<typeof schema>;

function FormRegister() {
    const dispatch = useDispatch<AppDispatch>();
    // const { loading, error, success } = useSelector((state: RootState) => state.auth);
    const { loading } = useSelector((state: RootState) => state.auth);
    const [formData, setFormData] = useState({
        email: "",
        password: "",
        fullName: "",
        gender: "",
        dateOfBirth: "",
        phoneNumber: "",
        address: "",
        avatarUrl: "",
        userType: "student",
        schoolGrade: 0,
        startDate: "",
        parentFullName: "",
        parentPhoneNumber: "",
        parentEmail: "",
        parentAddress: "",
        branchCode: "",
        courseCode: "",
        description: null as string | null,
    })

    const { control, handleSubmit, formState: { errors }, setFocus, setError, reset } = useForm<FormData>({
        resolver: yupResolver(schema) as Resolver<FormData>,
    });

    const onSubmit = async (data: FormData) => {
        const newData = {
            ...formData,
            email: data.email,
            password: data.password,
            fullName: data.studentName,
            gender: "other",
            dateOfBirth: data.birthDay,
            phoneNumber: data.phone,
            address: "",
            avatarUrl: "",
            status: "pending",
            userType: "student",
            schoolGrade: Number(data.grade),
            startDate: data.startDate,
            parentFullName: data.parentName,
            parentPhoneNumber: data.phone,
            parentEmail: "",
            parentAddress: "",
            branchCode: data.branch,
            courseCode: data.course,
            description: data.description
        }
        setFormData(newData)
        const cleanedData = Object.fromEntries(
            Object.entries(newData).filter(([_, value]) => value !== "")
        );
        try {
            await dispatch(createStudent(cleanedData)).unwrap();
            // Nếu thành công, reset form và show popup (như bạn đang làm)
            setShowPopup(true);
            reset({
                studentName: "",
                parentName: "",
                birthDay: "",
                email: "",
                password: "",
                phone: "",
                grade: "",
                course: "",
                branch: "",
                startDate: "",
                description: null,
            });
            setTimeout(() => setShowPopup(false), 5000);

        } catch (err: any) {
            // Nếu API trả về status 400 và message "User already exists"
            if (err?.status === STATUS.BAD_REQUEST && err?.data?.message.includes("already exists")) {
                setError("email", { type: "server", message: "Email này đã được sử dụng" });
                setFocus("email");
            } else {
                // Lỗi server khác
                console.log("Lỗi server khác:", err?.data?.message || err);
            }
        }
    };

    const onError = (err: any) => {
        const firstErrorField = Object.keys(err)[0];
        if (firstErrorField) setFocus(firstErrorField as keyof FormData);
    };
    const [showPopup, setShowPopup] = useState(false); // State quản lý việc hiển thị popup

    const handleClosePopup = () => {
        setShowPopup(false); // Đóng popup khi click "X" hoặc click vào overlay
    };

    const { data } = useGetAllBranch(1, 10);
    const { data: courseData } = useGetAllCourse(1, 10);

    const branchList = formatData(data?.data.items);
    const courseList = formatData(courseData?.data.items);
    return (
        <>{loading && (<Loading />)}
            {showPopup && <NotionPopup onClose={handleClosePopup} />} {/* Hiển thị popup khi success */}
            <form
                onSubmit={handleSubmit(onSubmit, onError)}
                className="flex flex-col mx-auto"
            >
                <div className="flex flex-col lg:flex-row gap-x-[40px]">
                    <div className="w-full lg:w-[calc(50%-20px)]">
                        <Controller
                            name="studentName"
                            control={control}
                            render={({ field }) => (
                                <InputText
                                    {...field}
                                    label="Họ và tên học sinh *"
                                    error={errors.studentName?.message} />
                            )} />
                    </div>
                    <div className="w-full lg:w-[calc(50%-20px)] mt-[40px] lg:mt-0">
                        <Controller
                            name="birthDay"
                            control={control}
                            render={({ field }) => (
                                <InputDate
                                    {...field}
                                    label="Ngày sinh *"
                                    error={errors.birthDay?.message} />
                            )} />
                    </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-x-[40px] mt-[40px]">
                    <div className="w-full lg:w-[calc(50%-20px)]">
                        <Controller
                            name="email"
                            control={control}
                            render={({ field }) => (
                                <InputText
                                    {...field}
                                    label="Email *"
                                    error={errors.email?.message} />
                            )} />
                    </div>
                    <div className="w-full lg:w-[calc(50%-20px)] mt-[40px] lg:mt-0">
                        <Controller
                            name="password"
                            control={control}
                            render={({ field }) => (
                                <InputText
                                    {...field}
                                    label="Mật khẩu"
                                    error={errors.password?.message}
                                    type="password" />
                            )} />
                    </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-x-[40px] mt-[40px]">
                    <div className="w-full lg:w-[calc(50%-20px)]">
                        <Controller
                            name="parentName"
                            control={control}
                            render={({ field }) => (
                                <InputText
                                    {...field}
                                    label="Họ và tên phụ huynh *"
                                    error={errors.parentName?.message} />
                            )} />
                    </div>
                    <div className="w-full lg:w-[calc(50%-20px)] mt-[40px] lg:mt-0">
                        <Controller
                            name="phone"
                            control={control}
                            render={({ field }) => (
                                <InputText
                                    {...field}
                                    label="Số điện thoại *"
                                    error={errors.phone?.message} />
                            )} />
                    </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-x-[40px] mt-[40px]">
                    <div className="w-full lg:w-[calc(50%-20px)]">
                        <Controller
                            name="grade"
                            control={control}
                            render={({ field }) => (
                                <InputSelect
                                    {...field}
                                    label="Lớp hiện tại *"
                                    error={errors.grade?.message}
                                    data={gradeListSelect} />
                            )} />
                    </div>
                    <div className="w-full lg:w-[calc(50%-20px)] mt-[40px] lg:mt-0">
                        <Controller
                            name="course"
                            control={control}
                            render={({ field }) => (
                                <InputSelect
                                    {...field}
                                    label="Chọn khóa học *"
                                    error={errors.course?.message}
                                    data={courseList} />
                            )} />
                    </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-x-[40px] mt-[40px]">
                    <div className="w-full lg:w-[calc(50%-20px)]">
                        <Controller
                            name="branch"
                            control={control}
                            render={({ field }) => (
                                <InputSelect
                                    {...field}
                                    label="Chọn cơ sở *"
                                    error={errors.grade?.message}
                                    data={branchList} />
                            )} />
                    </div>
                    <div className="w-full lg:w-[calc(50%-20px)] mt-[40px] lg:mt-0">
                        <Controller
                            name="startDate"
                            control={control}
                            render={({ field }) => (
                                <InputDate
                                    {...field}
                                    label="Ngày bắt đầu dự kiến *"
                                    error={errors.startDate?.message} />
                            )} />
                    </div>

                </div>
                <div className="flex flex-col lg:flex-row gap-x-[40px] mt-[40px]">
                    <div className="w-full">
                        <Controller
                            name="description"
                            control={control}
                            render={({ field }) => (
                                <InputArea
                                    {...field}
                                    label="Ghi chú thêm"
                                    error={errors.description?.message}
                                    placeholder="Thông tin bổ sung ..." />
                            )} />
                    </div>
                </div>
                <Button type="submit" label="Đăng ký học" styleButton="w-[140px] h-[45px] mx-auto mt-[40px]" />
            </form></>
    );
}

export default FormRegister;
